import notepaper from '../assets/notepaper.jpg';
import chalk from '../assets/chalk.jpg';
import grid from '../assets/grid.jpg';
import stone from '../assets/stone.jpg';

const nodeTextures = [
  { key: "notepaper", label: "Notepaper", preview: notepaper },
  { key: "chalk", label: "Chalkboard", preview: chalk },
  { key: "grid", label: "Science Grid", preview: grid },
  { key: "stone", label: "Stone Tablet", preview: stone },
];

export default nodeTextures;
